module.exports = __webpack_public_path__ + "application/templates/default/inner/account/partials/submenu/submenu.template.html";